export const validatePhone = (value: string | undefined | null) => {
  if (!value || typeof value !== "string") {
    return true;
  }

  if (value.trim() === "") {
    return true;
  }

  const digitsOnly = value.replace(/\D/g, "");
  return digitsOnly.length === 10 || "Phone numbers should have 10 digits";
};
